import React from 'react';
import { Link } from 'react-router-dom';
import { AppContext } from '../../App';
import { isSeoSettingsNoFollow } from '../../data/seo/seoUtils';
import { useAbsolutePath } from '../../data/seo/seoRouteUtils';
import { classIf } from '../../data/utils/classIf';


function CategoryLink(props) {
    const appContext = React.useContext(AppContext);
    const relativeCategoryPath = useAbsolutePath([props.urlPath, props.urlPathSuffix].join(''),null,props.urlPathSeo,true);
    const noFollow = isSeoSettingsNoFollow(props.urlPathSeoSettings);

    function handleClick(e){
        if (window.blockHistoryChanges()) {
            e.preventDefault();
            if(props.onClick){
                props.onClick();
            }
        }else{
            appContext.setHandleOpenFromPath(true)
        }
    }


    return (
        <Link to={encodeURI(relativeCategoryPath) } onClick={handleClick} {...(noFollow ? {rel: 'nofollow'}:{})} >
             <div key={props.id} className={"event-desc text-small" + classIf(props.selected, 'selected')}>
                <span>{props.descrizione}</span>
            </div>
        </Link>
    );
}

export default CategoryLink;